<p>inventory-aging works!</p>
